import React, { useState, Fragment } from "react"
import Button from "react-bootstrap/lib/Button"

import BubbleCard from "../../ui-components/BubbleCard"
import Stars from "./Stars"
import RatingModal from "./RatingModal"

import style from "../index.module.sass"

// ----------------------------------------------------------------------------

function RatingCard(props) {
  // -------------------------------------
  // Props destructuring
  // -------------------------------------

  const {
    order = {},
    userToken,
    alreadyRated = true,
    canBeRated = false,
  } = props

  // -------------------------------------
  // Hooks (e.g. useState, useMemo ...)
  // -------------------------------------

  const [showRatingModal, setShowRatingModal] = useState(false)

  // -------------------------------------
  // Effects
  // -------------------------------------

  // -------------------------------------
  // Component functions
  // -------------------------------------

  function handleHide(action) {
    if (action === "refresh") {
      window.location.reload()
    } else {
      setShowRatingModal(false)
    }
  }

  // -------------------------------------
  // Component local variables
  // -------------------------------------

  // -------------------------------------

  return (
    <div className={style.bubbleContainer}>
      <BubbleCard>
        <div className={style.inner}>
          {alreadyRated && (
            <Fragment>
              <p className={style.alreadyRatedThanks}>
                {I18n.t("pages.orders.show.thanks_for_evaluation")}
              </p>
              <p className={style.alreadyRatedTitle}>
                {I18n.t("pages.orders.show.average_evaluation")}
              </p>
              <Stars readOnly currentVote={order.rating.average} />
            </Fragment>
          )}

          {!alreadyRated && canBeRated && (
            <Fragment>
              <h2 className={style.title}>
                {I18n.t("pages.order_ratings.new.steps.intro.title", {
                  racer_fullname:
                    (order && order.racer && order.racer.first_name) || "",
                })}
              </h2>
              <Button
                className={`${style.button} btn-blue`}
                onClick={() => setShowRatingModal(true)}
              >
                {I18n.t("pages.order_ratings.new.steps.intro.button")}
              </Button>
            </Fragment>
          )}
        </div>

        <RatingModal
          show={showRatingModal}
          onHide={handleHide}
          order={order}
          userToken={userToken}
        />
      </BubbleCard>
    </div>
  )
}

// ----------------------------------------------------------------------------

export default RatingCard
